//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

	export default {
		data(){
			return {
				show:false
			}
		},
		props:{
			img:{
				type:String,
				required:true
			}
		},
		mounted(){
		},
		methods: {
			__show(){
				this.show=true
			}
		}
	}



// WEBPACK FOOTER //
// ./src/vue-components/pop/pop.vue